import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46996a88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_intro rel" }
const _hoisted_2 = {
  key: 0,
  class: "national_banner",
  src: "https://static-jp.theckb.com/static-asset/client/1688national/nation_pure_banner_v3.png",
  alt: ""
}
const _hoisted_3 = {
  key: 1,
  class: "nation_pure_banner_close"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "70",
  width: "1095",
  src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_pure_banner_close_2.png",
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "viewport rel" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-cen" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "159",
    height: "38",
    style: {"margin":"40px"},
    src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_specail2.png",
    alt: ""
  })
], -1))
const _hoisted_8 = { class: "specail_list" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "specil_content" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "header" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "title" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  height: "38",
  src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/natioin_close_btn.png",
  alt: ""
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar" }, null, -1))
const _hoisted_19 = { class: "searchContainer" }
const _hoisted_20 = { class: "viewport national_main flex-col flex-ter" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title1",
  height: "30",
  width: "373",
  src: "https://static-jp.theckb.com/static-asset/client/1688national/nation_logo_v2.png",
  alt: ""
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title2",
  height: "38",
  width: "696",
  src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_pure_text2.png",
  alt: ""
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title3 flex" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_pure_icon_4.png",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("1688 売れ筋ランキング検索")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_pure_icon_3.png",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("日本向けOEM工場調査")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_pure_icon_2.png",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("商品レビュースコア検索")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/national_pure_icon_1.png",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("割引商品リサーチ")
  ])
], -1))
const _hoisted_24 = { class: "searchBox" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("THE CKB X 1688 検索と1688.com検索の違い？ "),
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-wenhao1" })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "categrayList flex-wrap" }
const _hoisted_28 = ["onClick", "src"]
const _hoisted_29 = { class: "recommom" }
const _hoisted_30 = { class: "viewport" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "180",
    height: "29",
    src: "https://static-s.theckb.com/BusinessMarket/Client/national_pure_text4.png",
    alt: ""
  })
], -1))
const _hoisted_32 = { class: "recommonList flex-bwn" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "content" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "anxin flex-ter flex-cen" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "503",
    height: "57",
    src: "https://static-jp.theckb.com/static-asset/client/1688national/nation_pure_text7_1_v2.png",
    alt: ""
  })
], -1))

import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { reactive, computed, ref, onMounted, onUnmounted } from 'vue'
import { isJA, useRtfix } from '@/store'
import NationalSearch from '@/views/list/components/NationalSearch.vue'
import NationalTips from './NationalTips.vue'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const activeIndex = ref(0)
const openCard = ref(true)
const changeActive = (item: any) => {
  activeIndex.value = item.index
}

const changeOpenCard = (val: string) => {
  if (val === '1') {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: 'limited_discount'
      }
    })
  }
  openCard.value = !openCard.value
}

onMounted(() => {
  openCard.value = localStorage.getItem('__close_card__') === '1'
})

onUnmounted(() => {
  localStorage.setItem('__close_card__', '1')
})

// 是否展示协议
const visible = ref(false)

const specailList = [
  {
    group: [
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_3.png', title: '48時間納品', content: '<div  class="single">一部工場では24時間以内のスピード発送が可能</div><div  class="single">すべての商品が48時間以内に出荷可能</div>', index: 3 },
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_4.png', title: '在庫保証', content: '<div  class="single">他のサービスよりも優先して在庫確保可能!!</div><div class="tips">一部のサプライヤーから順次開始します</div>', index: 4 },
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_5.png', title: 'ロット数1点から買付可能', content: '<div class="single">ロット数1点から買付可能な工場を順次拡充</div><div class="single">D2Cビジネスユーザーにメリット</div>', index: 5 }
    ],
    url: 'https://static-s.theckb.com/BusinessMarket/Client/national_specail_group2.png'
  },
  {
    group: [
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_6.png', title: '1688 オフィシャル厳選品質', content: '<div class="single">B2B卸売市場主要のサイトー1688の商品の中で優良な1億点を厳選!!</div>', index: 6 },
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_7.png', title: '不良品7日以内無料交換', content: '<div class="single">7日間無条件返品商品厳選！</div><div class="single">CKB倉庫まで到着後1週間以内なら交換可能！</div><div class="tips">返品手数料は除く</div>', index: 7 },
      { url: 'https://static-s.theckb.com/BusinessMarket/Client/national_special_8.png', title: '人気商品検索機能', content: '<div class="single">1688 オフィシャルサイトで人気の商品＆高評価率95％以上の商品をフィルタリサーチ可能</div>', index: 8 }
    ],
    url: 'https://static-s.theckb.com/BusinessMarket/Client/national_specail_group3.png'
  }
]

const categrayList = [
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_11.png', label: 'レディースファッション', categoryId: '10166' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_10.png', label: 'メンズファッション', categoryId: '10165' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_9.png', label: '子供服', categoryId: '311' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_8.png', label: 'インテリア', categoryId: '96' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_7.png', label: 'スポーツ＆アウトドア', categoryId: '18' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_6.png', label: 'ペット用品', categoryId: '122916001' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_5.png', label: 'キッチン用品', categoryId: '201547801' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_4.png', label: 'バッグ', categoryId: '1042954' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_3.png', label: '収納', categoryId: '1548' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_2.png', label: 'アクセサリー', categoryId: '54' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_1.png', label: 'スマホ＆パソコン', categoryId: '7' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/icon_category_0.png', label: '車用品', categoryId: '122916002' }
]

const brandList = [
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_0.png', content: '厳選商品', target: 'https://cht.1688.com/index.html?spm=a260k.dacugeneral.home2019scene.d0.663335e4M74aBc' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_1.png', content: '新着商品', target: 'https://show.1688.com/shopping/xinpin/gjw7i4bm.html?spm=a260k.dacugeneral.home2019scene.d9.663335e4JYx1fB&__pageId__=197034&cms_id=197034' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_2.png', content: 'コミュニティ', target: 'https://club.1688.com/?spm=a260k.dacugeneral.home2019scene.d8.663335e4JYx1fB' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_3.png', content: '毎日セール', target: 'https://show.1688.com/test/pc_rax/asozxf4v.html?spm=a260k.dacugeneral.home2019scene.d5.663335e4M74aBc&__pageId__=232302&cms_id=232302' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_4.png', content: '越境EC限定商品', target: 'https://sale.1688.com/sale/kuajing/global/index.html?spm=a260k.dacugeneral.home2019scene.d3.663335e4M74aBc&__pageId__=188249&cms_id=188249&wh_pha=true#/home' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_5.png', content: 'スーパー工場', target: 'https://sale.1688.com/factory/bd_jpzz.html?spm=a260k.dacugeneral.home2019scene.d13.663335e4M74aBc&__existtitle__=1&__removesafearea__=1' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_6.png', content: 'タオバオ向けのセレクション', target: 'https://mindx.1688.com/fx/wydf/dwvgj16p7/index.html?spm=a260k.dacugeneral.home2019scene.d2.663335e4M74aBc&wh_pha=true&wh_pid=1873644&__pageId__=1873644' },
  { url: 'https://static-s.theckb.com/BusinessMarket/Client/1688national/nation_recommend_icon_7.png', content: '優良製品', target: 'https://sale.1688.com/sale/dacu/commonnew/uoqglmnu.html?spm=a260k.dacugeneral.home2019scene.d6.663335e4M74aBc&__pageId__=235026&cms_id=235026' }
]

const showTips = () => {
  visible.value = true
}

const gotoUrl = (url: string) => {
  // location.href=
  window.open(url, '_blank')
}

const route = useRoute()

/** 挑选国家站 */
const jumpToSearch = (item: any) => {
  taTrack({
    event: TaEvent.PRODUCT_SEARCH_1688,
    value: {
      category_id: item.categoryId,
      category_name: item.label
    }
  })
  store.commit('bussiness/platformType', 'AM')
  const query: any = {
    ...route.query,
    schannel: 2,
    platformType: 'AM',
    // 是否国家站
    national: 1,
    categoryId: item.categoryId
  }
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}
/** 去列表 */
const gotoList = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: '1688_more'
    }
  })
  store.commit('bussiness/platformType', 'AM')
  const query: any = {
    ...route.query,
    schannel: 2,
    categoryId: 0,
    platformType: 'AM',
    // 是否国家站
    national: 1
  }
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`container rel ${!openCard.value ? '' : 'close'}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!openCard.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(specailList, (item) => {
            return _createElementVNode("div", {
              class: "specail_item",
              key: item.url
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  class: "topic",
                  src: item.url,
                  alt: ""
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.group, (groupItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (changeActive(groupItem)),
                    class: _normalizeClass(`list_item ${groupItem.index === activeIndex.value}`),
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        class: "special_icon",
                        src: groupItem.url,
                        alt: ""
                      }, null, 8, _hoisted_13),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(groupItem.title), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "content",
                      innerHTML: groupItem.content
                    }, null, 8, _hoisted_15)
                  ], 10, _hoisted_11))
                }), 128))
              ])
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", {
        class: "close_btn cursor-pt",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeOpenCard('0')))
      }, _hoisted_17),
      _hoisted_18
    ]),
    _createElementVNode("img", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeOpenCard('1'))),
      height: "32",
      class: "abs open_btn cursor-pt",
      src: "https://static-s.theckb.com/BusinessMarket/Client/1688national/natioin_open_btn2.png"
    }),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createVNode(NationalSearch, { noBanner: true }),
          _createElementVNode("div", {
            class: "tips cursor-pt",
            onClick: showTips
          }, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categrayList, (item) => {
            return _createElementVNode("img", {
              class: "categray_img cursor-pt",
              onClick: ($event: any) => (jumpToSearch(item)),
              key: item.url,
              src: item.url,
              alt: ""
            }, null, 8, _hoisted_28)
          }), 64))
        ]),
        _createElementVNode("div", { class: "gotoList" }, [
          _createElementVNode("img", {
            class: "cursor-pt",
            onClick: gotoList,
            width: "228",
            height: "44",
            src: "https://static-s.theckb.com/BusinessMarket/Client/national_pure_btn.png",
            alt: ""
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(brandList, (item) => {
            return _createElementVNode("div", {
              onClick: ($event: any) => (gotoUrl(item.target)),
              class: "recommon_item flex-col flex-ter cursor-pt",
              key: item.url
            }, [
              _createElementVNode("img", {
                width: "56",
                height: "57",
                src: item.url,
                alt: ""
              }, null, 8, _hoisted_34),
              _createElementVNode("div", _hoisted_35, _toDisplayString(item.content), 1)
            ], 8, _hoisted_33)
          }), 64))
        ])
      ])
    ]),
    _hoisted_36,
    _createVNode(NationalTips, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event))
    }, null, 8, ["visible"])
  ], 2))
}
}

})